const Events = {
  ContinueShopping: 'continue-shopping',
  ViewCart: 'view-cart'
};

export default Events;
